// Declared twice so that docs appear when selecting colors
export interface EdisonPalette extends Record<string, string> {
  /** **#FCF2DF** Yellow */
  readonly edison10: string;
  /** **#FEE9C3** Yellow */
  readonly edison30: string;
  /** **#FFDB89** Yellow */
  readonly edison60: string;
  /** **#FFC651** Yellow */
  readonly edisonPrimary: string;
  /** **#DE9809** Yellow */
  readonly edison80: string;
  /** **#9B6D0F** Yellow */
  readonly edison90: string;
}

export const edisonPalette: EdisonPalette = {
  edison10: '#FCF2DF',
  edison30: '#FEE9C3',
  edison60: '#FFDB89',
  edisonPrimary: '#FFC651',
  edison80: '#DE9809',
  edison90: '#9B6D0F',
};
